import {
  GET_PARTICIPANT_ASSESSMENT,
  GET_PARTICIPANT_ASSESSMENT_RESULT,
  REDIRECT_TO,
  RESET_REDIRECTION,
  SET_SELECTED_ANSWER,
} from "./actionsTypes";
import {
  setFetching,
  setError,
} from "../../shared/request/actions/requestActions";
import { participantPortalUrl } from "../../common/config";
import { LOCAL_REDIRECTION_PATHS } from "../consts/localRedirectionPaths";

import {
  getAssessment,
  getAssasmentsResult,
  confirmAssessmentVideo,
  storeAssessmentAnswer,
  validateEmailParticipant,
  finishAssessment,
} from "../service";

export const GENERIC_ERROR_MESSAGE = "Unexpected error";

const REDIRECT_STATUS = 302;
const PARTICIPANT_LOGIN_PATH = "/";

export const getErrorMessageFromRequestError = (error) => {
  let message = `${GENERIC_ERROR_MESSAGE}`;

  if (error?.response?.data) {
    message = error.response.data.errors.length
      ? error.response.data.errors.toString()
      : error.response.data.warnings.toString();
  }

  return message;
};

export const setRedirectTo = ({ isRedirect, isExternalURL, redirectTo }) => ({
  type: REDIRECT_TO,
  payload: { isRedirect, isExternalURL, redirectTo },
});

export const resetRedirection = () => ({ type: RESET_REDIRECTION });

export const handleErrorResponse = ({ error, dispatch }) => {
  const message = getErrorMessageFromRequestError(error);

  dispatch(setError({ isOpen: true, message, type: "error" }));
};

export const handleRedirectionResponse = ({ error, dispatch }) => {
  const redirectTo = error?.response?.data;
  const isExternalURL =
    !LOCAL_REDIRECTION_PATHS.some((localPath) =>
      redirectTo.includes(localPath)
    ) || redirectTo === PARTICIPANT_LOGIN_PATH;

  dispatch(
    setRedirectTo({
      isExternalURL,
      redirectTo,
      isRedirect: true,
    })
  );
};

export const handleAssessmentProcessErrorResponse = ({ error, dispatch }) => {
  if (error?.response && Number(error?.response?.status) === REDIRECT_STATUS)
    handleRedirectionResponse({ error, dispatch });
  else {
    dispatch(
      setRedirectTo({
        isExternalURL: false,
        redirectTo: "",
        isRedirect: false,
      })
    );
    handleErrorResponse({ error, dispatch });
  }
};

export const setParticipantAssessment = ({
  assessmentTemplate,
  participantAnswers,
}) => ({
  type: GET_PARTICIPANT_ASSESSMENT,
  payload: {
    assessmentTemplate,
    participantAnswers,
  },
});

export const setParticipantAssessmentResult = (result) => ({
  type: GET_PARTICIPANT_ASSESSMENT_RESULT,
  payload: result,
});

export const asyncVerifyAssessmentVideo =
  (participantProfileId) => async (dispatch) => {
    dispatch(setFetching({ isFetching: true }));
    try {
      await confirmAssessmentVideo(participantProfileId);
    } catch (error) {
      handleErrorResponse({ error, dispatch });
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const asyncValidateWelcomeAssessmentProcess =
  (participantProfileId) => async (dispatch) => {
    dispatch(setFetching({ isFetching: true }));

    try {
      await validateEmailParticipant(participantProfileId);
      await confirmAssessmentVideo(participantProfileId);
      await getAssessment(participantProfileId);
    } catch (error) {
      handleAssessmentProcessErrorResponse({ error, dispatch });
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const setParticipantAnswer = ({ answerId, questionId }) => ({
  type: SET_SELECTED_ANSWER,
  payload: { answerId, questionId },
});

export const asyncSubmitParticipantAnswer =
  ({ participantProfileId, answerId, questionId }) =>
  async (dispatch) => {
    dispatch(setFetching({ isFetching: true }));

    try {
      const response = await storeAssessmentAnswer({
        participantProfileId,
        answerId,
        questionId,
      });

      if (response.status === 200 && response.data.data) {
        dispatch(setParticipantAnswer({ answerId, questionId }));
      }
    } catch (error) {
      handleErrorResponse({ error, dispatch });
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const asyncGetParticipantAssessment =
  (participantProfileId) => async (dispatch) => {
    dispatch(setFetching({ isFetching: true }));
    try {
      const response = await getAssessment(participantProfileId);
      if (response && response.status === 200) {
        dispatch(setParticipantAssessment(response.data.data));
      }
    } catch (error) {
      handleAssessmentProcessErrorResponse({ error, dispatch });
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const asyncFinishParticipantAssessment =
  (participantProfileId) => async (dispatch) => {
    dispatch(setFetching({ isFetching: true }));

    try {
      const response = await finishAssessment(participantProfileId);

      if (response.status === 200) {
        dispatch(
          setError({
            isOpen: true,
            message: "You have completed your assessment",
            type: "success",
          })
        );
      }
    } catch (error) {
      handleAssessmentProcessErrorResponse({ error, dispatch });
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const asyncGetParticipantAssessmentResult =
  (participantProfileId) => async (dispatch) => {
    dispatch(setFetching({ isFetching: true }));

    try {
      const response = await getAssasmentsResult(participantProfileId);
      dispatch(setParticipantAssessmentResult(response.data.data));
    } catch (error) {
      handleErrorResponse({ error, dispatch });
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const redirectToParticipant = (path) => {
  const search = window.location.search;
  const newURL = `${participantPortalUrl}${path}${search}`
    .replace("??", "?")
    .replace(/\?/g, "&")
    .replace("/&", "/?");
  window.location.replace(newURL);
};
